

export const OpenSolicitudEditarEliminacion = (modalAction, detalleSolicitudSol) => ({
  type: "OPEN_SOLICITUD_EDITAR_ELIMINACION",
  modalAction,
  detalleSolicitudSol,
});

export const CambiarInicioVigenciaArancel = (inicioVigenciaArancel, error) => ({
  type: "SOLEDIT_ELIMINACION/CAMBIAR_INICIO_VIGENCIA_ARANCEL",
  inicioVigenciaArancel,
  error,
});



// WEBPACK FOOTER //
// ./src/components/ActualizarArancel/SolicitudEditarEliminacion/actions.js